function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "add-seed-active_svg__a",
  d: "M16.75 4.385L15.365 3l-5.49 5.49L4.385 3 3 4.385l5.49 5.49L3 15.365l1.385 1.385 5.49-5.49 5.49 5.49 1.385-1.385-5.49-5.49z"
}));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-.804 -.804)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#23d3cd",
  transform: "rotate(45 9.875 9.875)",
  xlinkHref: "#add-seed-active_svg__a"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9.875,
  cy: 9.875,
  r: 5.5,
  stroke: "#23d3cd"
}));
function SvgAddSeedActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='18' height='18' viewBox='0 0 18 18'%3e %3cdefs%3e %3cpath id='prefix__a' d='M16.75 4.385L15.365 3 9.875 8.49 4.385 3 3 4.385 8.49 9.875 3 15.365 4.385 16.75 9.875 11.26 15.365 16.75 16.75 15.365 11.26 9.875z'/%3e %3c/defs%3e %3cg fill='none' fill-rule='evenodd' transform='translate(-.804 -.804)'%3e %3cuse fill='%2323d3cd' transform='rotate(45 9.875 9.875)' xlink:href='%23prefix__a'/%3e %3ccircle cx='9.875' cy='9.875' r='5.5' stroke='%2323d3cd'/%3e %3c/g%3e %3c/svg%3e";
export { SvgAddSeedActive as ReactComponent };